import { jsx as _jsx } from "react/jsx-runtime";
import { useFormControl } from '@mui/material/FormControl';
import { useAriaProps, useDataProps } from '@famly/mf_ts-utils_data-aria-props';
import { ToggleControl } from './toggle-control';
export const StandaloneToggle = (props) => {
    var _a, _b, _c;
    const dataProps = useDataProps(props);
    const ariaProps = useAriaProps(props);
    const { disabled: disabledFromFormControl } = (_a = useFormControl()) !== null && _a !== void 0 ? _a : {};
    const disabled = (_b = props.disabled) !== null && _b !== void 0 ? _b : disabledFromFormControl;
    return (_jsx(ToggleControl, { checked: props.checked, disabled: disabled, id: props.id, onChange: props.onChange, size: props.size, inputProps: {
            ...ariaProps,
            'aria-label': (_c = ariaProps['aria-label']) !== null && _c !== void 0 ? _c : props.ariaLabel,
        }, ...dataProps }));
};
